// eslint-disable-next-line max-len
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { FlatTreeControl } from '@angular/cdk/tree';
import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import * as cloneDeep from 'lodash/cloneDeep';
import { Subject } from 'rxjs';
import {
  FeatureItemFlatNode,
  FeatureItemNode,
  Hierarchy,
  SiteModel,
  SiteStepperModel
} from 'src/app/models/index';
import {
  CommonService,
  SiteService,
  SiteStepperService
} from 'src/app/services/index';
import {
  AlertService,
  AppUtils,
  Constants,
  SiteStepperEnum
} from 'src/app/shared';
import { AddNodeTreeConfigurationModalComponent } from './add-node-tree-configuration-modal/add-node-tree-configuration-modal.component';

@Component({
  selector: 'app-tree-configuration',
  templateUrl: './tree-configuration.component.html',
  styleUrls: ['./tree-configuration.component.scss']
})
export class TreeConfigurationComponent
  extends Hierarchy
  implements OnInit, AfterViewInit, OnDestroy
{
  // eslint-disable-next-line @typescript-eslint/member-ordering
  @ViewChild('tree') tree;
  callLoadOnSubject: Subject<any> = new Subject();
  callInverterSubject: Subject<any> = new Subject();
  callGenericSubject: Subject<any> = new Subject();
  siteId = '';
  siteModel: SiteModel;
  stepTitle = 'Tree Configuration';
  currentNode: {
    nodeData: any;
    metersId: any;
    nodeTitle: string;
    nodeType: string;
    loadId: string;
    meterId: string;
    loadRId: string;
    kwRating: any;
  } = Object.assign({});
  isST_load: boolean;
  isMeter: undefined | boolean = undefined;
  copyToLoadOnViewRadio: any;
  copyToInverterViewRadio: any;
  copyToTransformerViewRadio: any;
  treeConfiguration: {
    treeData: any;
    loadONTreeData: any;
    inverterTreeData: any;
    genericTreeData: any;
  } = Object.assign({});
  treeData: any;
  loadONTreeData: any;
  inverterTreeData: any;
  genericTreeData: any;
  selectedTreeType: any;
  currentProcessTreeType: any;
  nodeInfoModalMode: any;
  nodeInfoModalTitle = '';
  uploadedFile: any;
  dashboardNameInputEnabled = false;
  maxTreeLevel = 12;
  startId = 0;
  nodeInfoModalMode_newFirst = 1;
  nodeInfoModalMode_new = 2;
  nodeInfoModalMode_edit = 3;
  treeType = {
    STATIC_TREE: 'STATIC_TREE',
    LOAD_ON_TREE: 'LOAD_ON_TREE',
    INVERTER_TREE: 'INVERTER_TREE',
    GENERIC_TREE: 'GENERIC_TREE'
  };
  nodeType = Constants.NODE_TYPE;
  selectedMetersRId = [];
  selectedProcessesRId = [];
  selectedMetersRId_staticTree = [];
  selectedProcessesRId_staticTree = [];
  selectedMetersRId_loadONTree = [];
  selectedProcessesRId_loadONTree = [];
  selectedMetersRId_inverterTree = [];
  selectedProcessesRId_inverterTree = [];
  selectedMetersRId_transformerTree = [];
  selectedProcessesRId_transformerTree = [];
  newInverterNodeImgsRId = [];
  removedInverterNodeImgsRId = [];
  dataSource: any;
  expandedNodeSet = new Set<string>();
  dragging = false;
  expandTimeout: any;
  expandDelay = 1000;
  randomId = 1;
  processAndLoads: any;
  constructor(
    private siteStepperService: SiteStepperService,
    private siteService: SiteService,
    private commonService: CommonService,
    private alertService: AlertService,
    private activeRoute: ActivatedRoute,
    private fb: UntypedFormBuilder,
    private dialog: MatDialog
  ) {
    super();
  }

  ngOnInit() {
    const seft = this;
    this.siteModel = new SiteModel();
    this.siteStepperService.getStepperSubject().subscribe((data) => {
      if (
        data.selectedIndex === SiteStepperEnum.TreeConfiguration &&
        !this.commonService.isNullOrUndefined(data.siteModel)
      ) {
        if (this.siteModel && this.siteModel.siteId !== undefined) {
          this.siteId = this.siteModel.siteId;
        } else {
          this.siteId = this.activeRoute.snapshot.queryParams['siteId'];
        }
        this.siteModel = data.siteModel;
        this.siteService
          .getTreeConfiguration(this.siteId, [
            'treeData',
            'loadONTreeData',
            'inverterTreeData',
            'genericTreeData'
          ])
          .subscribe((treeConfig) => {
            this.dataSource.data = [];
            this.siteService
              .getProcessAndLoadsBySiteId(this.siteId, true)
              .subscribe(function (res) {
                seft.processAndLoads = res;
              });

            if (
              treeConfig.treeData !== undefined &&
              treeConfig.treeData !== null &&
              treeConfig.treeData !== 'null' &&
              treeConfig.treeData !== ''
            ) {
              this.treeData = JSON.parse(treeConfig.treeData);
              // build selected meters and processes
              for (let i = 0; i < this.treeData.length; i++) {
                this.getSelectedMeterRecursive(
                  this.treeData[i],
                  this.selectedMetersRId_staticTree
                );
                this.getSelectedProcessRecursive(
                  this.treeData[i],
                  this.selectedProcessesRId_staticTree
                );
              }
              this.dataSource.data = this.buildFileTree(
                this.treeData[0],
                this.dataSource.data,
                null,
                true
              );
            }
            if (
              treeConfig.loadONTreeData !== undefined &&
              treeConfig.loadONTreeData !== null &&
              treeConfig.loadONTreeData !== 'null' &&
              treeConfig.loadONTreeData !== ''
            ) {
              this.loadONTreeData = JSON.parse(treeConfig.loadONTreeData);
              this.callLoadOnSubject.next(this.loadONTreeData);
              // build selected meters and processes
              for (let j = 0; j < this.loadONTreeData.length; j++) {
                this.getSelectedMeterRecursive(
                  this.loadONTreeData[j],
                  this.selectedMetersRId_loadONTree
                );
                this.getSelectedProcessRecursive(
                  this.loadONTreeData[j],
                  this.selectedProcessesRId_loadONTree
                );
              }
            }
            if (
              treeConfig.inverterTreeData !== undefined &&
              treeConfig.inverterTreeData !== null &&
              treeConfig.inverterTreeData !== 'null' &&
              treeConfig.inverterTreeData !== ''
            ) {
              this.inverterTreeData = JSON.parse(treeConfig.inverterTreeData);
              this.callInverterSubject.next(this.inverterTreeData);
              // build selected meters and processes
              for (let k = 0; k < this.inverterTreeData.length; k++) {
                this.getSelectedMeterRecursive(
                  this.inverterTreeData[k],
                  this.selectedMetersRId_inverterTree
                );
                this.getSelectedProcessRecursive(
                  this.inverterTreeData[k],
                  this.selectedProcessesRId_inverterTree
                );
              }
            }
            if (
              treeConfig.genericTreeData !== undefined &&
              treeConfig.genericTreeData !== null &&
              treeConfig.genericTreeData !== 'null' &&
              treeConfig.genericTreeData !== '[]' &&
              treeConfig.genericTreeData !== ''
            ) {
              this.genericTreeData = JSON.parse(treeConfig.genericTreeData);
              this.callGenericSubject.next(this.genericTreeData);
              // build selected meters and processes
              for (let i = 0; i < this.genericTreeData.length; i++) {
                this.getSelectedMeterRecursive(
                  this.genericTreeData[i],
                  this.selectedMetersRId_transformerTree
                );
                this.getSelectedProcessRecursive(
                  this.genericTreeData[i],
                  this.selectedProcessesRId_transformerTree
                );
              }
            }
          });
      }
    });
  }
  ngAfterViewInit() {
    this.tree.treeControl.collapseAll();
  }

  ngOnDestroy() {
    this.callLoadOnSubject.unsubscribe();
    this.callInverterSubject.unsubscribe();
    this.callGenericSubject.unsubscribe();
  }

  buildFileTree(
    obj: any,
    nodes: any,
    currentSelected: FeatureItemFlatNode,
    firstTime?: boolean
  ): FeatureItemNode[] {
    const node = Object.assign({}, obj);
    node.title = obj.title;
    // node.id = obj.id;
    node.id = this.randomId++;
    node.level = obj.level;
    node.index = obj.index;
    node.nodeType = obj.nodeType;
    node.subType = obj.subType;
    node.processId = obj.processId !== undefined ? obj.processId : 'NA';
    // node.processRId = obj.processRId !== undefined ? obj.processRId : 'NA';
    node.meterId = obj.meterId !== undefined ? obj.meterId : 'NA';
    // node.meterRId = obj.meterRId;
    node.loadId = obj.loadId !== undefined ? obj.loadId : 'NA';
    // node.loadRId = obj.loadRId !== undefined ? obj.loadRId : 'NA';
    node.kwRating = obj.kwRating;
    node.parameters = obj.parameters;
    if (firstTime && this.commonService.isNullOrUndefined(node.nodes)) {
      node.nodes = [];
    }
    if (currentSelected != null && currentSelected.nodeId === obj.nodeId) {
      node.selected = true;
    }
    if (obj.nodes !== undefined && obj.nodes.length > 0) {
      node.nodes = [];
      // obj.nodes.forEach(element => {
      //   node.nodes = this.buildFileTree(element, node.nodes, currentSelected);
      // });
      for (let i = 0; i < obj.nodes.length; i++) {
        const element = obj.nodes[i];
        element.index = i;
        node.nodes = this.buildFileTree(element, node.nodes, currentSelected);
      }
    }
    return nodes.concat(node);
  }

  initTree(treeType) {
    this.setScopeVariablesByTreeType(treeType);
    this.nodeInfoModalMode = this.nodeInfoModalMode_newFirst;

    const dialogRef = this.dialog.open(AddNodeTreeConfigurationModalComponent, {
      width: '60%'
      // height: auto
    });
    dialogRef.componentInstance.siteId = this.siteId;
    dialogRef.componentInstance.nodeInfoModalTitle = 'Add Node';
    dialogRef.componentInstance.selectedTreeType = treeType;
    dialogRef.componentInstance.uploadedFile = undefined;
    dialogRef.componentInstance.dashboardNameInputEnabled = true;
    dialogRef.componentInstance.nodeInfoModalMode = this.nodeInfoModalMode;
    dialogRef.componentInstance.nodeData = {};
    dialogRef.componentInstance.processes = this.processAndLoads;
    dialogRef.afterClosed().subscribe((result) => {
      if (result.status === true) {
        switch (treeType) {
          case this.treeType.STATIC_TREE:
            this.treeData = result.data.treeData;
            this.dataSource.data = this.buildFileTree(
              this.treeData[0],
              this.dataSource.data,
              null
            );
            break;
          case this.treeType.LOAD_ON_TREE:
            this.loadONTreeData = result.data.loadONTreeData;
            this.callLoadOnSubject.next(this.loadONTreeData);
            break;
          case this.treeType.INVERTER_TREE:
            this.inverterTreeData = result.data.inverterTreeData;
            this.callInverterSubject.next(this.inverterTreeData);
            break;
          case this.treeType.GENERIC_TREE:
            this.genericTreeData = result.data.genericTreeData;
            this.callGenericSubject.next(this.genericTreeData);
            break;
        }
      }
    });
  }

  setScopeVariablesByTreeType(treeType) {
    if (treeType === this.treeType.STATIC_TREE) {
      this.selectedMetersRId = this.selectedMetersRId_staticTree;
      this.selectedProcessesRId = this.selectedProcessesRId_staticTree;
    } else if (treeType === this.treeType.LOAD_ON_TREE) {
      this.selectedMetersRId = this.selectedMetersRId_loadONTree;
      this.selectedProcessesRId = this.selectedProcessesRId_loadONTree;
    } else if (treeType === this.treeType.INVERTER_TREE) {
      this.selectedMetersRId = this.selectedMetersRId_inverterTree;
      this.selectedProcessesRId = this.selectedProcessesRId_inverterTree;
    } else if (treeType === this.treeType.GENERIC_TREE) {
      this.selectedMetersRId = this.selectedMetersRId_transformerTree;
      this.selectedProcessesRId = this.selectedProcessesRId_transformerTree;
    }
    this.currentProcessTreeType = treeType;
  }
  getSelectedMeterRecursive(node, selectedMetersRId) {
    // if (node.meterRId !== undefined) {
    //   selectedMetersRId.push(node.meterRId);
    // }
    if (!this.commonService.isNullOrUndefined(node.meterId)) {
      selectedMetersRId.push(node.meterId);
    }
    if (node.nodes !== undefined) {
      for (let i = 0; i < node.nodes.length; i++) {
        this.getSelectedMeterRecursive(node.nodes[i], selectedMetersRId);
      }
    }
  }

  getSelectedProcessRecursive(node: any, selectedProcessesRId: any) {
    // if (node.processRId !== undefined) {
    //   this.selectedProcessesRId.push(node.processRId);
    // }
    if (!this.commonService.isNullOrUndefined(node.processId)) {
      this.selectedProcessesRId.push(node.processId);
    }
    if (node.nodes !== undefined) {
      for (let i = 0; i < node.nodes.length; i++) {
        this.getSelectedProcessRecursive(node.nodes[i], selectedProcessesRId);
      }
    }
  }
  /** Toggle the feature item selection. Select/deselect all the descendants node */
  public featureItemSelectionToggle(node: FeatureItemFlatNode): void {}
  /** Toggle a leaf feature item selection. Check all the parents to see if they changed */
  public featureLeafItemSelectionToggle(node: FeatureItemFlatNode): void {
    // this.setCurrentNode(node);
  }

  copyToLoadOnViewRadioChange(value) {
    this.copyToLoadOnViewRadio = value;
    if (this.copyToLoadOnViewRadio === 'yes') {
      this.loadONTreeData = Object.assign([], this.treeData);
      this.callLoadOnSubject.next(this.loadONTreeData);
      // build selected meters and processes
      for (let j = 0; j < this.loadONTreeData.length; j++) {
        this.getSelectedMeterRecursive(
          this.loadONTreeData[j],
          this.selectedMetersRId_loadONTree
        );
        this.getSelectedProcessRecursive(
          this.loadONTreeData[j],
          this.selectedProcessesRId_loadONTree
        );
      }
    }
  }
  copyToInverterViewRadioChange(value) {
    this.copyToInverterViewRadio = value;
    if (this.copyToInverterViewRadio === 'yes') {
      this.inverterTreeData = Object.assign([], this.treeData);
      this.callInverterSubject.next(this.inverterTreeData);
      // build selected meters and processes
      for (let k = 0; k < this.inverterTreeData.length; k++) {
        this.getSelectedMeterRecursive(
          this.inverterTreeData[k],
          this.selectedMetersRId_inverterTree
        );
        this.getSelectedProcessRecursive(
          this.inverterTreeData[k],
          this.selectedProcessesRId_inverterTree
        );
      }
    }
  }
  copyToTransformerViewRadioChange(value) {
    this.copyToTransformerViewRadio = value;
    if (this.copyToTransformerViewRadio === 'yes') {
      this.genericTreeData = Object.assign([], this.treeData);
      this.callGenericSubject.next(this.genericTreeData);
      // build selected meters and processes
      for (let i = 0; i < this.genericTreeData.length; i++) {
        this.getSelectedMeterRecursive(
          this.genericTreeData[i],
          this.selectedMetersRId_transformerTree
        );
        this.getSelectedProcessRecursive(
          this.genericTreeData[i],
          this.selectedProcessesRId_transformerTree
        );
      }
    }
  }
  private getAllMetersIdOfNode = (node: any, metersId: any) => {
    if (node.meterId !== 'NA') {
      metersId.push(node.meterId);
    }
    if (node.nodes !== undefined && node.nodes.length > 0) {
      for (let i = 0; i < node.nodes.length; i++) {
        metersId = this.getAllMetersIdOfNode(node.nodes[i], metersId);
      }
    }
    return metersId;
  };
  private setCurrentNode = (node: FeatureItemNode | FeatureItemFlatNode) => {
    this.isST_load = true;
    if (node.nodeType === Constants.NODE_TYPE.METER) {
      this.isST_load = false;
    } else if (node.nodeType === Constants.NODE_TYPE.LOAD) {
      this.isST_load = false;
      if (node.subType !== undefined && node.subType === 'StratificationTank') {
        this.isST_load = true;
      }
    }
    this.currentNode.nodeData = node;
    const metersId = this.getAllMetersIdOfNode(node, []);
    this.currentNode.metersId = AppUtils.uniqueArray(metersId);
    this.currentNode.nodeTitle = node.title;
    this.currentNode.nodeType = node.nodeType;
    if (node.nodeType === Constants.NODE_TYPE.METER) {
      this.isMeter = true;
      this.currentNode.meterId = node.meterId;
      this.currentNode.loadId = node.meterId;
      this.isST_load = false;
    } else if (node.nodeType === Constants.NODE_TYPE.LOAD) {
      this.isMeter = false;
      this.isST_load = false;
      this.currentNode.meterId = node.meterId;
      this.currentNode.loadId = node.loadId;
      // this.currentNode.loadRId = node.loadRId;
      this.currentNode.kwRating = node.kwRating;
      if (node.subType !== undefined && node.subType === 'StratificationTank') {
        this.isST_load = true;
      }
    }
  };

  // CRUD
  newSubItem(scope, treeType) {
    this.currentNode = scope;
    this.dashboardNameInputEnabled = false;
    this.selectedTreeType = treeType;
    this.setScopeVariablesByTreeType(treeType);
    this.nodeInfoModalMode = this.nodeInfoModalMode_new;

    const dialogRef = this.dialog.open(AddNodeTreeConfigurationModalComponent, {
      width: '40%',
      height: '62%'
    });
    dialogRef.componentInstance.siteId = this.siteId;
    dialogRef.componentInstance.nodeInfoModalTitle = 'Add New Node';
    dialogRef.componentInstance.selectedTreeType = treeType;
    dialogRef.componentInstance.uploadedFile = undefined;
    dialogRef.componentInstance.dashboardNameInputEnabled = true;
    dialogRef.componentInstance.nodeInfoModalMode = this.nodeInfoModalMode;
    dialogRef.componentInstance.nodeData = scope;
    dialogRef.componentInstance.processes = this.processAndLoads;
    dialogRef.afterClosed().subscribe((result) => {
      if (result.status === true) {
        this.currentNode = result.data.nodeData;
        const src = [];
        this.dataSource.data = this.buildFileTree(
          this.dataSource.data[0],
          src,
          null
        );
        this.treeData = cloneDeep(this.dataSource.data);
      }
    });
  }

  editNode(scope, treeType) {
    const t = this;
    this.dashboardNameInputEnabled = false;
    this.currentNode = scope;
    this.selectedTreeType = treeType;
    this.setScopeVariablesByTreeType(treeType);
    this.nodeInfoModalMode = this.nodeInfoModalMode_edit;

    const dialogRef = this.dialog.open(AddNodeTreeConfigurationModalComponent, {
      width: '40%',
      height: '62%'
    });
    dialogRef.componentInstance.siteId = this.siteId;
    dialogRef.componentInstance.nodeInfoModalTitle = 'Modify Node';
    dialogRef.componentInstance.selectedTreeType = treeType;
    dialogRef.componentInstance.uploadedFile = undefined;
    dialogRef.componentInstance.dashboardNameInputEnabled = true;
    dialogRef.componentInstance.nodeInfoModalMode = this.nodeInfoModalMode;
    dialogRef.componentInstance.nodeData = scope;
    dialogRef.componentInstance.processes = this.processAndLoads;
    dialogRef.afterClosed().subscribe((result) => {
      if (result.status === true) {
        t.currentNode = result.data.nodeData;
        t.updateNode(scope, t.currentNode);
        t.treeData = cloneDeep(this.dataSource.data);
      }
    });
  }

  removeNodeItem(scope, treeType) {
    this.currentNode = scope;
    this.setScopeVariablesByTreeType(treeType);
    const nodeData = scope;
    this.unselectMeterOrProcess(nodeData);

    const parentNode = this.getParent(scope);
    if (parentNode === undefined || parentNode === null) {
      this.dataSource.data = [];
    } else if (parentNode.nodes !== undefined) {
      for (let i = 0; i < parentNode.nodes.length; i++) {
        const tempNode = <any>parentNode.nodes[i];
        if (tempNode.index !== undefined && tempNode.index === scope.index) {
          parentNode.nodes.splice(i, 1);
          break;
        }
      }
    }

    this.treeData = cloneDeep(this.dataSource.data);
    this.dataSource.data = this.dataSource.data;
  }
  unselectMeterOrProcess(nodeData) {
    // if (nodeData.nodeType === this.nodeType.TEXT) {
    //   for (let i = 0; i < nodeData.nodes.length; i++) {
    //     this.unselectMeterOrProcess(nodeData.nodes[i]);
    //   }
    // } else if (nodeData.meterRId !== undefined) {
    //   for (let i = 0; i < this.selectedMetersRId.length; i++) {
    //     if (this.selectedMetersRId[i] === nodeData.meterRId) {
    //       this.selectedMetersRId.splice(i, 1);
    //     }
    //   }
    // } else if (nodeData.processRId !== undefined) {
    //   for (let i = 0; i < this.selectedProcessesRId.length; i++) {
    //     if (this.selectedProcessesRId[i] === nodeData.processRId) {
    //       this.selectedProcessesRId.splice(i, 1);
    //     }
    //   }
    // }
    if (nodeData.nodeType === this.nodeType.TEXT) {
      for (let i = 0; i < nodeData.nodes.length; i++) {
        this.unselectMeterOrProcess(nodeData.nodes[i]);
      }
    } else if (!this.commonService.isNullOrUndefined(nodeData.meterId)) {
      for (let i = 0; i < this.selectedMetersRId.length; i++) {
        if (this.selectedMetersRId[i] === nodeData.meterId) {
          this.selectedMetersRId.splice(i, 1);
        }
      }
    } else if (!this.commonService.isNullOrUndefined(nodeData.processId)) {
      for (let i = 0; i < this.selectedProcessesRId.length; i++) {
        if (this.selectedProcessesRId[i] === nodeData.processId) {
          this.selectedProcessesRId.splice(i, 1);
        }
      }
    }
  }
  private getParent = (node: any) => {
    const currentLevel = this.treeControl.getLevel(node);
    if (currentLevel < 1) {
      return null;
    }
    const startIndex = this.treeControl.dataNodes.indexOf(node) - 1;
    for (let i = startIndex; i >= 0; i--) {
      const currentNode = this.treeControl.dataNodes[i];

      if (this.treeControl.getLevel(currentNode) < currentLevel) {
        return currentNode;
      }
    }
  };
  // private updateNode = (data: any, nodeData: any) => {
  //   for (let i = 0; i < data.length; i++) {
  //     const node = data[i];
  //     if (node.index === nodeData.index) {
  //       Object.assign(node, nodeData);
  //       break;
  //     }
  //     if (node.nodes !== undefined && node.nodes !== null && node.nodes.length > 0) {
  //       this.updateNode(node.nodes, nodeData);
  //     }
  //   }

  // }
  private updateNode = (oldnode: any, newnode: any) => {
    const parentNode = this.getParent(oldnode);
    if (parentNode === null) {
      Object.assign(oldnode, newnode);
    } else {
      for (let i = 0; i < parentNode.nodes.length; i++) {
        const tempNode = <any>parentNode.nodes[i];
        if (tempNode.index !== undefined && tempNode.index === oldnode.index) {
          Object.assign(tempNode, newnode);
          break;
        }
      }
    }
  };
  // Load on view actions
  updateBackFromLoadOnView(data: any) {
    this.loadONTreeData = data.loadONTreeData;
    this.setScopeVariablesByTreeType(this.treeType.LOAD_ON_TREE);
    if (data.nodeData !== null) {
      this.unselectMeterOrProcess(data.nodeData);
    }
  }
  // Inverter tree view actions
  updateBackFromInverterView(data: any) {
    this.inverterTreeData = data.inverterTreeData;
    this.setScopeVariablesByTreeType(this.treeType.INVERTER_TREE);
    if (data.nodeData !== null) {
      this.unselectMeterOrProcess(data.nodeData);
    }
  }
  // Inverter tree view actions
  updateBackFromGenericView(data: any) {
    this.genericTreeData = data.genericTreeData;
    this.setScopeVariablesByTreeType(this.treeType.GENERIC_TREE);
    if (data.nodeData !== null) {
      this.unselectMeterOrProcess(data.nodeData);
    }
  }
  private rememberExpandedTreeNodes(
    treeControl: FlatTreeControl<FeatureItemFlatNode>,
    expandedNodeSet: Set<string>
  ) {
    if (treeControl.dataNodes) {
      treeControl.dataNodes.forEach((node) => {
        if (treeControl.isExpandable(node) && treeControl.isExpanded(node)) {
          // capture latest expanded state
          expandedNodeSet.add(node.id.toString());
        }
      });
    }
  }
  /**
   * This constructs an array of nodes that matches the DOM,
   * and calls rememberExpandedTreeNodes to persist expand state
   */
  visibleNodes(): FeatureItemNode[] {
    this.rememberExpandedTreeNodes(this.treeControl, this.expandedNodeSet);
    const result = [];

    function addExpandedChildren(node: FeatureItemNode, expanded: Set<string>) {
      result.push(node);
      if (expanded.has(node.id.toString())) {
        node.nodes.forEach((child) => addExpandedChildren(child, expanded));
      }
    }
    this.dataSource.data.forEach((node) => {
      addExpandedChildren(node, this.expandedNodeSet);
    });
    return result;
  }
  /**
   * Handle the drop - here we rearrange the data based on the drop event,
   * then rebuild the tree.
   * */
  drop(event: CdkDragDrop<string[]>) {
    // console.log('origin/destination', event.previousIndex, event.currentIndex);
    // ignore drops outside of the tree
    if (!event.isPointerOverContainer) {
      return;
    }

    // construct a list of visible nodes, this will match the DOM.
    // the cdkDragDrop event.currentIndex jives with visible nodes.
    // it calls rememberExpandedTreeNodes to persist expand state
    const visibleNodes = this.visibleNodes();

    // deep clone the data source so we can mutate it
    const changedData = JSON.parse(JSON.stringify(this.dataSource.data));

    // recursive find function to find siblings of node
    function findNodeSiblings(arr: Array<any>, id: string): Array<any> {
      let result, subResult;
      arr.forEach((item) => {
        if (item.id.toString() === id) {
          result = arr;
        } else if (item.nodes) {
          subResult = findNodeSiblings(item.nodes, id);
          if (subResult) {
            result = subResult;
          }
        }
      });
      return result;
    }

    // remove the node from its old place
    const node = event.item.data;
    const siblings = findNodeSiblings(changedData, node.id.toString());
    const siblingIndex = siblings.findIndex((n) => n.id === node.id);
    const nodeToInsert: FeatureItemNode = siblings.splice(siblingIndex, 1)[0];

    // determine where to insert the node
    const nodeAtDest = visibleNodes[event.currentIndex];
    if (nodeAtDest.id === nodeToInsert.id) {
      return;
    }

    // determine drop index relative to destination array
    let relativeIndex = event.currentIndex; // default if no parent
    const nodeAtDestFlatNode = this.treeControl.dataNodes.find(
      (n) => nodeAtDest.id === n.id
    );
    const parent = this.getParentNode(nodeAtDestFlatNode);
    if (parent) {
      const parentIndex = visibleNodes.findIndex((n) => n.id === parent.id) + 1;
      relativeIndex = event.currentIndex - parentIndex;
    }
    // insert node
    const newSiblings = findNodeSiblings(
      changedData[0].nodes,
      nodeAtDest.id.toString()
    );
    if (!newSiblings) {
      return;
    }
    newSiblings.splice(relativeIndex, 0, nodeToInsert);
    // rebuild tree with mutated data
    this.rebuildTreeForData(changedData);
  }
  rebuildTreeForData(data: any) {
    this.rememberExpandedTreeNodes(this.treeControl, this.expandedNodeSet);
    this.dataSource.data = data;
    this.forgetMissingExpandedNodes(this.treeControl, this.expandedNodeSet);
    this.expandNodesById(
      this.treeControl.dataNodes,
      Array.from(this.expandedNodeSet)
    );
    this.treeData = cloneDeep(this.dataSource.data);
  }
  private forgetMissingExpandedNodes(
    treeControl: FlatTreeControl<FeatureItemFlatNode>,
    expandedNodeSet: Set<string>
  ) {
    if (treeControl.dataNodes) {
      expandedNodeSet.forEach((nodeId) => {
        // maintain expanded node state
        if (
          !treeControl.dataNodes.find((n) => n.nodeId.toString() === nodeId)
        ) {
          // if the tree doesn't have the previous node, remove it from the expanded list
          expandedNodeSet.delete(nodeId);
        }
      });
    }
  }

  private expandNodesById(flatNodes: FeatureItemFlatNode[], ids: string[]) {
    if (!flatNodes || flatNodes.length === 0) {
      return;
    }
    const idSet = new Set(ids);
    return flatNodes.forEach((node) => {
      if (idSet.has(node.id.toString())) {
        this.treeControl.expand(node);
        let parent = this.getParentNode(node);
        while (parent) {
          this.treeControl.expand(parent);
          parent = this.getParentNode(parent);
        }
      }
    });
  }
  private getParentNode(node: FeatureItemFlatNode): FeatureItemFlatNode | null {
    const currentLevel = node.level;
    if (currentLevel < 1) {
      return null;
    }
    const startIndex = this.treeControl.dataNodes.indexOf(node) - 1;
    for (let i = startIndex; i >= 0; i--) {
      const currentNode = this.treeControl.dataNodes[i];
      if (currentNode.level < currentLevel) {
        return currentNode;
      }
    }
    return null;
  }
  /**
   * Experimental - opening tree nodes as you drag over them
   */
  dragStart() {
    this.dragging = true;
  }
  dragEnd() {
    this.dragging = false;
  }
  dragHover(node: any) {
    if (this.dragging) {
      clearTimeout(this.expandTimeout);
      this.expandTimeout = setTimeout(() => {
        this.treeControl.expand(node);
      }, this.expandDelay);
    }
  }
  dragHoverEnd() {
    if (this.dragging) {
      clearTimeout(this.expandTimeout);
    }
  }
  // main Tree actions
  public previousStep = (event: any) => {
    event.preventDefault();
    this.siteStepperService.setSendStepper(true);
    this.siteStepperService.sendStepperSubject(
      new SiteStepperModel(
        SiteStepperEnum.DataAcquisitionLayout,
        this.siteModel
      )
    );
  };
  nextStep = (event: any) => {
    event.preventDefault();
    this.siteStepperService.setSendStepper(true);
    this.siteStepperService.sendStepperSubject(
      new SiteStepperModel(
        SiteStepperEnum.ClickAndNavigationDetails,
        this.siteModel
      )
    );
  };
  saveTreeConfiguration() {
    const t = this;
    this.treeConfiguration.treeData = JSON.stringify(this.treeData);
    this.treeConfiguration.loadONTreeData = JSON.stringify(this.loadONTreeData);
    this.treeConfiguration.inverterTreeData = JSON.stringify(
      this.inverterTreeData
    );
    this.treeConfiguration.genericTreeData = JSON.stringify(
      this.genericTreeData
    );

    if (t.removedInverterNodeImgsRId.length > 0) {
      t.removedInverterNodeImgsRId = t.commonService.uniqueArray(
        t.removedInverterNodeImgsRId
      );
      t.siteService
        .deleteAttachmentByRIds(t.removedInverterNodeImgsRId)
        .subscribe((data) => {
          // console.log('deleteAttachmentByRIds: ' + t.removedInverterNodeImgsRId + ': ' + data);
          t.removedInverterNodeImgsRId = [];
        });
    }
    if (t.newInverterNodeImgsRId.length > 0) {
      t.newInverterNodeImgsRId = t.commonService.uniqueArray(
        t.newInverterNodeImgsRId
      );
      this.siteService
        .saveAttachmentByRIds(t.newInverterNodeImgsRId)
        .subscribe((data) => {
          // console.log('saveAttachmentByRIds: ' + newInverterNodeImgsRId + ': ' + data);
          t.newInverterNodeImgsRId = [];
        });
    }
    t.siteService
      .saveTreeConfiguration(t.siteId, t.treeConfiguration)
      .subscribe((data) => {
        t.treeConfiguration = data;
        t.alertService.showSuccess(Constants.MESSAGE.Save_success);
      });
  }
}
